import type { TranslateString } from '@/types/translation.types';
import { isObject } from 'underscore';

export const isTranslateString = (content: unknown): content is TranslateString => {
  if (isObject(content) && 'base' in content) {
    return true;
  } else {
    return false;
  }
};

export default isTranslateString;
